/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-10 10:41:19
 * @LastEditors: caiqin.xie
 * @message: 自定义分类内容详情-标题组件
 */
import React from "react";
import {CopyToClipboard} from "react-copy-to-clipboard"
import { Notification } from '@arco-design/web-react';
import styles from "../../index.module.scss";
import { IContentDetail } from "@/common/types";

const Facebook_icon = require('../../../../../../static/images/Facebook.svg');
const Twitter_icon = require('../../../../../../static/images/Twitter.svg');
const message_icon = require('../../../../../../static/images/message.jpg');

interface IProps {
  ctry: string;
  words: Record<string, string>;
  newsDetail: IContentDetail;
}

const ArticleTitle = (props:IProps) => {
  const {ctry, words, newsDetail} = props

  // 复制邮箱
  const handleCopy = () => {
    console.log('copy success')
    Notification.success({
      title: '',
      content: words?.blog_copy_email_success,
    })
    // Replicating Success
  }
  return (
    <div className={styles['article-title']}>
      <h1>{newsDetail?.title}</h1>
      {newsDetail && newsDetail.authorDetailVO && (
        <p className={styles['article-author']}>
          <span className={styles['article-name']}>{newsDetail.authorDetailVO?.name}</span> 
          <span className={styles['article-icon']}>
            <a href={newsDetail.authorDetailVO?.faceBook} target="_blank"><img src={Facebook_icon} alt={words?.common_facebook} /></a>
            <a href={newsDetail.authorDetailVO?.twitter} target="_blank"><img src={Twitter_icon} alt={words?.common_twitter} /></a>
            {newsDetail.authorDetailVO.email && (
              <CopyToClipboard
                onCopy={handleCopy}
                text={newsDetail.authorDetailVO.email}>
                <span className={`${styles.cp} ${styles['eamil-wrap']}`}>
                  <img src={message_icon} alt={words?.common_email} />{newsDetail.authorDetailVO.email}
                </span>
              </CopyToClipboard>
            )}
          </span>
        </p>
      )}
    </div>
  )
}
export default ArticleTitle